import ArrowLeft from "@mui/icons-material/ArrowLeft";
import { Box, Grid, Link, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Types } from "Types";
import Libelle from "../../../_i18n/fr.json";
import FormContainer from "../../../components/FormContainer";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import { Selectors as DossierLocationSelectors } from "../../../redux/DossierLocation";
import { useGetRapportAlgo } from "../../../hooks/DossierLocation";
import styles from "../SyntheseDossierLocationPage/Synthese/styles";
import CalculLocataires from "./CalculLocataires";

function CalculLoyerPage() {
  const selectedDossier = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getSelectedDossier(state)
  );
  const {
    data: rapportAlgo,
    error,
    isLoading: fetching,
    mutate: getRapportAlgo,
  } = useGetRapportAlgo();
  useEffect(() => {
    if (selectedDossier) {
      getRapportAlgo(selectedDossier);
    }
  }, []);

  return (
    <Layout title={Libelle.pageBien.titre}>
      <Box sx={styles}>
        <Link
          href="/dossier-location/synthese"
          color="inherit"
          className="backLink"
        >
          <ArrowLeft /> Retour à la synthèse
        </Link>
        <Typography variant="h4" className={"statut"}>
          Détail du calcul du dossier {selectedDossier}
        </Typography>
        <LoadingBoundary
          loading={fetching}
          error={error}
          onRetry={() => selectedDossier && getRapportAlgo(selectedDossier)}
        >
          <FormContainer>
            <Grid container className={"synthese"}>
              {rapportAlgo?.dossierLocation && (
                <div>
                  <h3>Calcul du loyer max conseillé</h3>
                  <p>
                    Revenus mensuels du dossier :
                    <strong>
                      {rapportAlgo?.dossierLocation.revenusMensuelsDossier}€
                    </strong>
                  </p>
                  <p>
                    CAF mensuelles du dossier :
                    <strong>
                      {rapportAlgo?.dossierLocation.aidesSocialesMensuelles}€
                    </strong>
                  </p>
                  <p>
                    Ressources mensuelles du dossier :
                    <strong>
                      {rapportAlgo?.dossierLocation.ressourcesMensuellesDossier}
                      €
                    </strong>
                  </p>
                  <p>
                    Charges mensuelles du dossier :
                    <strong>
                      {rapportAlgo?.dossierLocation.chargesMensuellesDossier}€
                    </strong>
                  </p>
                  <h5>
                    Loyer max conseillé :{" "}
                    <strong>
                      {rapportAlgo?.dossierLocation.calculLoyerMaxConseille &&
                        rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                          .loyerMaxConseille}
                      €
                    </strong>
                  </h5>
                  <br />
                  <h3>Calcul des charges du dossier</h3>
                  {rapportAlgo?.dossierLocation.calculLoyerMaxConseille && (
                    <>
                      <p>
                        Code postal du bien :{" "}
                        <strong>
                          {rapportAlgo?.dossierLocation.bien &&
                            rapportAlgo?.dossierLocation.bien.codePostal}
                        </strong>
                      </p>
                      <p>
                        Charge UC :{" "}
                        <strong>
                          {
                            rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                              .chargeUc
                          }
                          €
                        </strong>
                      </p>
                      <p>
                        Nombre UC :{" "}
                        <strong>
                          {
                            rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                              .nombreUc
                          }
                        </strong>
                      </p>
                      <p>
                        Nombre UC Adultes :{" "}
                        <strong>
                          {
                            rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                              .nombreUcAdultes
                          }
                        </strong>
                      </p>
                      <p>
                        Nombre UC Enfants de 14 ans et moins :{" "}
                        <strong>
                          {
                            rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                              .nombreUcEnfants14AnsEtMoins
                          }
                        </strong>
                      </p>
                      <p>
                        Nombre UC Enfants de plus de 14 ans :{" "}
                        <strong>
                          {
                            rapportAlgo?.dossierLocation.calculLoyerMaxConseille
                              .nombreUcEnfantsPlusDe14Ans
                          }
                        </strong>
                      </p>
                    </>
                  )}
                </div>
              )}

              <CalculLocataires
                data={
                  rapportAlgo?.dossierLocation &&
                  rapportAlgo?.dossierLocation.dossiersParticuliers
                    ? rapportAlgo?.dossierLocation.dossiersParticuliers
                    : []
                }
                typeDossier={
                  (rapportAlgo?.dossierLocation &&
                    rapportAlgo?.dossierLocation.compositionLocation) ||
                  ""
                }
              />
            </Grid>
          </FormContainer>
        </LoadingBoundary>
      </Box>
    </Layout>
  );
}

export default CalculLoyerPage;
